import styled from "@emotion/styled";

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 16px;
  font-family: Inter;
  height: 100svh;
`;

export const OnboardingSummary = styled.h1`
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  color: #e9ecf5;
  margin: 16px;
`;

export const OnboardingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  gap: 12px;
  padding-top: 8px;
`;

export const OnboardingElement = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 100%;
  height: 60px;
  padding-left: 22px;
  padding-right: 12px;
  border-radius: 12px;
  background: #1e1f22;
  border: 1px solid #2b2d33;
`;

export const OnboardingElementTitle = styled.div`
  font-size: 15px;
  line-height: 120%;
  font-weight: 600;
  text-align: center;
  color: #e9ecf5;
`;

export const OnboardingElementIcon = styled.img`
  margin-left: auto;
`;

export const HomeButton = styled.button`
  height: 44px;
  width: 100%;
  border-radius: 12px;
  background: transparent;
  border: 1px solid #5e84ed;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  color: #5e84ed;
  margin-top: auto;
  text-align: center;
  margin-bottom: 110px;
`;

export const ReviewChatWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  padding-bottom: 66px;
  overflow-y: auto;
  height: 100svh;
  box-sizing: border-box;
`;

export const ReplayMessage = styled.p`
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  color: #b7bdcb;
  margin-bottom: 12px;
`;
